import { TaskService } from "@/modules/Tasks/services/TaskService";
import {
  USER_ACCESS,
  USER_STATES
} from "@/modules/User/constants/UserConstants";
import { UserStatus } from "@/modules/User/models/UserStatus";
import { UserService } from "@/modules/User/services/UserService";
import {
  FilterOneItem,
  QueryFilter
} from "@/shared/components/GenericSearchBar/model/FilterOneItem";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  FORM_CONSTANTS,
  FORM_MESSAGES
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Http } from "@status/codes";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import {
  FILTER_SEARCH_USER_CONSTANTS,
  PROFILE_CONSTANTS
} from "../../constants/ProfileConstants";
import SearchOneFilter from "./../../../../shared/components/GenericSearchBar/components/SearchOneFilter/SearchOneFilter.vue";
import {
  GENERAL_CONSTANTS,
  NAME_FINDERS
} from "./../../../../shared/constants/GeneralConstants";
import {
  TASK_ACCESS,
  TASK_CONSTANTS
} from "@/modules/Tasks/constants/TaskConstants";
import { FormsData } from "@/modules/Forms/models/FormsData";
import lodash from "lodash";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { AVAILABILITY_CONSTANTS } from "@/modules/Availability/constants/AvailabilityConstants";
import { DependenciesService } from "@/modules/Dependencies/services/DependenciesService";
import { UserQuery } from "@/modules/User/models/UserQuery";
import { UserPagination } from "@/modules/User/models/UserPagination";
import { QuerySendMultiple } from "@/shared/models/FormQuerySend";
import { FILTER_QUERY_DEFAULT_DEPENDENCIES } from "@/modules/Dependencies/constants/DependenciesConstants";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import {
  ACTION_TASK_CONSTANTS,
  DOCUMENT_STATES
} from "@/modules/Dashboards/AdminDashboard/constants/ActionConstants";

@Component({
  name: "AssignTask",
  components: { SearchOneFilter, DynamicSelect }
})
export default class AssignTask extends Vue {
  @Inject() userService!: UserService;
  @Inject() taskService!: TaskService;
  @Inject() dependenciesService!: DependenciesService;

  @Prop() dialog!: boolean;
  @Prop() task!: FormsData;

  USER_ASSIGN_TASK_KEY = NAME_FINDERS.USER_ASSIGN_TASK;
  USER_LABEL = PROFILE_CONSTANTS.LABELS.USER;
  USER_HINT = PROFILE_CONSTANTS.HINT.USER;
  LOAD_MORE_TEXT = PROFILE_CONSTANTS.LABELS.LOAD_MORE_TEXT;
  TASK_CAT = PROFILE_CONSTANTS.LABELS.TASK_CATEGORY;
  TITLE = PROFILE_CONSTANTS.RESPONSABLE;
  LABELS = ACTION_TASK_CONSTANTS.LABELS;
  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  ACCEPT_BTN = FORM_CONSTANTS.BUTTON.ACCEPT;
  userFilters = PROFILE_CONSTANTS.USER_FILTERS;
  INPUT_RESPONSIBLE = TASK_CONSTANTS.LABELS.RESPONSIBLE;
  INPUT_DEPENDENCY = AVAILABILITY_CONSTANTS.LABEL.DEPENDENCY;

  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  cardClass = STYLE_CLASSES.CARD;

  clearAll = 0;
  searchUser = "";
  userLastRef = "";
  userFilter = PROFILE_CONSTANTS.USER_FILTERS_NAMES.ID;
  listUsers: UserStatus[] = [];
  usersChosen: UserStatus[] = [];
  responsibleChosen: DynamicSelectData[] = [];

  lastRefResponsible = "";
  listResponsibles: DynamicSelectData[] = [];
  responsibleSelectConfig: DynamicSelectConfig = {
    multiple: true,
    default: [],
    listAll: [],
    chips: true,
    filled: false,
    messageLabel: this.INPUT_RESPONSIBLE,
    notFound: false,
    persistenthint: true,
    loadingData: true,
    attach: false
  };

  lastRefDependency = "";
  dependencyChosen: DynamicSelectData[] = [];
  dependencySelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: [],
    chips: true,
    filled: false,
    messageLabel: this.INPUT_DEPENDENCY,
    notFound: false,
    persistenthint: true,
    loadingData: true,
    attach: false
  };

  @Watch("userFilter")
  resetFilter() {
    this.userLastRef = "";
    this.listUsers = [];
  }

  itemFilter: FilterOneItem = {
    ...FILTER_SEARCH_USER_CONSTANTS,
    getData: this.getPatientData
  };

  mounted() {
    this.responsibleChosen = lodash.cloneDeep(
      this.task.responsibles! as DynamicSelectData[]
    );
  }

  async getPatientData(query: QueryFilter): Promise<UserStatus[]> {
    let listPatient: UserStatus[] = [];
    try {
      const filterQuery = {
        ...query,
        userState: "Activo"
      };
      const responseData = await this.userService.getUserByFilters(filterQuery);
      if (responseData.code === Http.Found && responseData.data) {
        listPatient = responseData.data.userArray;
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${USER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
    return listPatient;
  }

  async assign() {
    try {
      const responseData = await this.taskService.assignTask(
        this.task.formTemplate.taskId,
        (this.responsibleChosen as UserStatus[]).map(user => user.id)
      );
      if (responseData.code === Http.Ok) {
        this.close(true);
        Snackbar.popSuccess(responseData.message);
      } else {
        this.close();
        Snackbar.popWarning(responseData.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${TASK_ACCESS.PUT}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  deleteUserChosen(item: DynamicSelectData) {
    this.clearSelect();
    this.responsibleChosen = this.responsibleChosen.filter(
      user => user.id !== item.id
    );
  }
  clearSelect() {
    this.clearAll = 1 - this.clearAll;
  }

  close(refresh = false) {
    this.clearSelect();
    this.responsibleChosen = [];
    this.searchUser = "";
    this.listUsers = [];
    this.$emit("closeAssignModal", refresh);
  }

  async loadResponsibles(name?: string) {
    this.responsibleSelectConfig.loadingData = true;
    try {
      if (name && name !== "") {
        const users = await this.handleUserByName(name);
        if (Object.keys(users).length === 0) {
          this.responsibleSelectConfig.loadingData = false;
          return;
        }
        const usersList: DynamicSelectData[] = users.userArray.map(item => ({
          id: item.id as string,
          name: item.name as string,
          userAvatar: item.userAvatar,
          userDocument: item.userDocument,
          userPhone: item.userPhone
        }));

        this.listResponsibles = !this.lastRefResponsible
          ? usersList
          : [...this.listResponsibles, ...usersList];

        this.lastRefResponsible = users.lastReference
          ? users.lastReference.toString()
          : "";
        //this.listResponsibles = [...this.listResponsibles, ...users];
        this.responsibleSelectConfig.listAll = this.listResponsibles;
        this.responsibleSelectConfig.loadingData = false;
        return;
      }
      const filterQuery: UserQuery = {
        userState: USER_STATES.ACTIVE,
        idReference: this.lastRefResponsible
      };

      if (this.dependencyChosen.length > 0) {
        filterQuery.dependency = [this.dependencyChosen[0].name];
      }

      const response = await this.userService.getUserByFilters(filterQuery);

      this.responsibleSelectConfig.notFound = response.code === Http.NotFound;
      if (response.code === Http.Found && response.data) {
        const responseData = response.data;
        const responseArray = responseData.userArray as DynamicSelectData[];
        this.listResponsibles = !this.lastRefResponsible
          ? responseArray
          : [...this.listResponsibles, ...responseArray];

        this.lastRefResponsible = responseData.lastReference
          ? responseData.lastReference.toString()
          : "";
      }
    } catch (error) {
      Snackbar.popError(TASK_CONSTANTS.TASK_SNACKBAR.REQUEST_FAILED);
    }
    this.responsibleSelectConfig.loadingData = false;
    this.responsibleSelectConfig.listAll = this.responsibleSelectConfig.listAll.concat(
      this.listResponsibles
    );
  }

  async handleUserByName(name: string): Promise<UserPagination> {
    const filterQuery: UserQuery = {
      name: [name],
      state: USER_STATES.ACTIVE,
      notPaginate: true
    };

    if (this.dependencyChosen.length > 0) {
      filterQuery.dependency = [this.dependencyChosen[0].name];
    }

    const responseUsers = await this.userService.getUsersByFiltersArrayUsersCrud(
      filterQuery
    );
    if (responseUsers.code == Http.Found && responseUsers.data) {
      const response = responseUsers.data;
      return response;
    } else return {} as UserPagination;
  }

  async loadDependencies(name?: string) {
    this.dependencySelectConfig.loadingData = true;
    try {
      if (name && name !== "") {
        const dependenciesResponse = await this.dependenciesService.getDependenciesWithFilters(
          {
            state: [DOCUMENT_STATES.ACTIVE],
            name: name
          }
        );
        if (
          dependenciesResponse.code === Http.Found &&
          dependenciesResponse.data
        ) {
          const moreDependencies = dependenciesResponse.data.data.map(item => {
            return { id: item.id as string, name: item.name as string };
          });

          this.dependencySelectConfig.listAll = moreDependencies;
          this.dependencySelectConfig.loadingData = false;
          this.lastRefDependency = dependenciesResponse.data.docRef;
          return;
        }
      }
      const filterQuery: QuerySendMultiple = {
        state: [FILTER_QUERY_DEFAULT_DEPENDENCIES.userState],
        docref: this.lastRefDependency,
        name: name
      };
      const dependenciesResponse = await this.dependenciesService.getDependenciesWithFilters(
        filterQuery
      );
      if (
        dependenciesResponse.code === Http.Found &&
        dependenciesResponse.data
      ) {
        const mooreDependencies = dependenciesResponse.data.data.map(item => {
          return { id: item.id as string, name: item.name as string };
        });

        this.dependencySelectConfig.listAll = this.dependencySelectConfig.listAll.concat(
          mooreDependencies
        );
        this.dependencySelectConfig.loadingData = false;
        this.lastRefDependency = dependenciesResponse.data.docRef;
        return;
      }
    } catch (error) {
      Snackbar.popError(TASK_CONSTANTS.TASK_SNACKBAR.REQUEST_FAILED);
    }
    this.dependencySelectConfig.loadingData = false;
  }
}
